import { useEffect } from 'react';
import { useCinematicStore } from '../../store/cinematicSlice';
import { cinematicService } from '../../services/CinematicService';
import { useMenuNavigation } from '../../hooks/menu/useMenuNavigation';
import { audioService } from '../../services/AudioService';
import { Icon } from './Icon';
import './ItemShowcaseScreen.scss';

const SHOWCASE_SFX = 'ui-confirm';

export const ItemShowcaseScreen = () => {
  const showcase = useCinematicStore((s) => s.showcase);

  useEffect(() => {
    if (showcase) {
      void audioService.playSfx(SHOWCASE_SFX);
    }
  }, [showcase]);

  const { containerRef } = useMenuNavigation({
    onConfirm: () => cinematicService.dismissShowcase(),
    onCancel: () => cinematicService.dismissShowcase(),
  });

  if (!showcase) {
    return null;
  }

  return (
    <div className="showcase-overlay" ref={containerRef}>
      <div
        className="showcase-content"
        data-nav-row={0}
        data-nav-col={0}
        data-nav-id="dismiss"
      >
        <div className="showcase-glow" />
        <div className="showcase-item" key={showcase.sprite}>
          <Icon sprite={showcase.sprite} size={96} />
        </div>
        <div className="showcase-name">{showcase.label}</div>
      </div>
    </div>
  );
};
